module.exports = __webpack_public_path__ + "media/images/course/depo_01-f13ab52b92a53569ebb7ba1282a81d97.png";